import React, { useState, useEffect } from "react";
import useAxiosPrivate from "../../../hooks/useAxiosPrivate";
import HandleHttpErrors from "../../HandleHttpErrors";
import { useNavigate, useLocation } from "react-router-dom";
import { Spinner } from "react-bootstrap";
import Add from "./Add";
import DisplayEmail from "./DisplayEmail";
import GetParsedDate from "../../shared/GetParsedDate";

const TopRight = ({ bhinaMeeting, newEmail, setNewEmail }) => {
  return (
    <div
      style={{
        height: "50px",
        backgroundColor: "#c2c2c2",
        fontWeight: "bold",
        fontSize: "20px",
      }}
    >
      <center>דואר הזמנת המועמדים לראיון</center>
    </div>
  );
};

const BottomRight = ({
  bhinaMeeting,
  newEmail,
  setNewEmail,
  emailToDisplay,
  setEmailToDisplay,
}) => {
  const axiosPrivate = useAxiosPrivate("application/json");
  const navigate = useNavigate();
  const location = useLocation();
  const [emails, setEmails] = useState([]);
  const [loading, setLoading] = useState(true);
  const bhinaMeeting_id = bhinaMeeting.id;

  useEffect(() => {
    let isMounted = true;
    const controller = new AbortController();

    const getData = async () => {
      try {
        const response = await axiosPrivate.get(
          "/jobs/bhinaMeetingemail?bhinaMeeting_id=" + bhinaMeeting_id,
          {
            signal: controller.signal,
          }
        );

        //isMounted && console.log("response.data");

        setEmails(
          response.data.sort((a, b) => {
            return b.id - a.id;
          })
        );
        setLoading(false);
      } catch (err) {
        if (err.response) {
          alert(HandleHttpErrors(err.response.status));
          console.log(err.response);
        } else if (err.request) {
          alert(
            " The client never received a response, and the request was never left"
          );
          console.log(err.request);
        } else {
          alert(" Anything else");
        }
      }
    };
    getData();

    return () => {
      isMounted = false;
      isMounted && controller.abort();
    };
  }, [newEmail]);
  if (loading) {
    // Render a spinner while the data is loading
    return (
      <div
        className="d-flex justify-content-center align-items-center"
        style={{ height: "100vh" }}
      >
        <div className="text-center">
          <Spinner animation="border" variant="danger" visible />

          <br />
          <br />
          <h3 className="spinnerText">המתן...</h3>
        </div>
      </div>
    );
  } else {
    return (
      <div
        style={{
          height: "calc(100vh - 90px)",
          overflowY: "scroll",
          backgroundColor: "#f2f2f2",
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            fontWeight: "bold",
          }}
        >
          מספר המילים: {emails.length}
        </div>
        {emails?.map((email) => {
          const date = new Date(email.send_date);
          const sendDate = GetParsedDate({ strDate: date, withTime: true });

          return (
            <div>
              <li key={email.id}>
                <button
                  className="small-button"
                  onClick={() => {
                    setEmailToDisplay(email);
                    setNewEmail(false);
                  }}
                >
                  {sendDate}: {email.moamad_name}
                </button>
              </li>
            </div>
          );
        })}
      </div>
    );
  }
};

const LeftComponent = ({
  bhinaMeeting,
  newEmail,
  emailToDisplay,
  mailTypeOptions,
  setNewEmail,
  setEmailToDisplay,
}) => (
  <div
    style={{
      height: "calc(100vh - 40px)",
      overflowY: "scroll",
      backgroundColor: "#e6e6e6",
      width: "75%",
    }}
  >
    {newEmail ? (
      <Add
        bhinaMeeting={bhinaMeeting}
        mailTypeOptions={mailTypeOptions}
        setNewEmail={setNewEmail}
        setEmailToDisplay={setEmailToDisplay}
      />
    ) : (
      <DisplayEmail
        email={emailToDisplay}
        bhinaMeeting={bhinaMeeting}
        mailTypeOptions={mailTypeOptions}
      />
    )}
  </div>
);

const RightComponent = ({
  bhinaMeeting,
  newEmail,
  setNewEmail,
  emailToDisplay,
  setEmailToDisplay,
}) => {
  return (
    <div style={{ display: "flex", flexDirection: "column", width: "25%" }}>
      <TopRight
        bhinaMeeting={bhinaMeeting}
        setNewEmail={setNewEmail}
        newEmail={newEmail}
      />
      <BottomRight
        bhinaMeeting={bhinaMeeting}
        setNewEmail={setNewEmail}
        newEmail={newEmail}
        emailToDisplay={emailToDisplay}
        setEmailToDisplay={setEmailToDisplay}
      />
    </div>
  );
};

const Emails = ({ visible, bhinaMeeting }) => {
  const [newEmail, setNewEmail] = useState(false);
  const [emailToDisplay, setEmailToDisplay] = useState({});
  const [mailTypeOptions, setMailTypeOptions] = useState([]);
  const axiosPrivate = useAxiosPrivate("application/json");

  useEffect(() => {
    let isMounted = true;
    const controller = new AbortController();

    const getData = async () => {
      try {
        const response = await axiosPrivate.get("/jobs/mailtype", {
          signal: controller.signal,
        });

        //isMounted && console.log(response.data);

        setMailTypeOptions(response.data[0].mailtypeOptions);
      } catch (err) {
        if (err.response) {
          alert(HandleHttpErrors(err.response.status));
          console.log(err.response);
        } else if (err.request) {
          alert(
            " The client never received a response, and the request was never left"
          );
          console.log(err.request);
        } else {
          alert(" Anything else");
        }
      }
    };
    getData();
    return () => {
      isMounted = false;
      isMounted && controller.abort();
    };
  }, []);
  if (!visible) return;
  return (
    <div style={{ display: "flex", flexDirection: "row" }}>
      <RightComponent
        bhinaMeeting={bhinaMeeting}
        newEmail={newEmail}
        setNewEmail={setNewEmail}
        emailToDisplay={emailToDisplay}
        setEmailToDisplay={setEmailToDisplay}
      />
      <LeftComponent
        bhinaMeeting={bhinaMeeting}
        newEmail={newEmail}
        emailToDisplay={emailToDisplay}
        mailTypeOptions={mailTypeOptions}
        setNewEmail={setNewEmail}
        setEmailToDisplay={setEmailToDisplay}
      />
    </div>
  );
};

export default Emails;
